import { useContext } from 'react';
import { SystemContext } from '../System';
import { LayerManager } from '../layers/LayerManager';

export function useLayerManager(): LayerManager {
  const system = useContext(SystemContext);
  return system.layerManager;
}
